import { useRef } from 'react';

export const useDebounce = (func, delay, leading, dependencyList) => {
    const ref = useRef({
        timer: null,
        deps: [],
        callback: func
    });

    const context = ref.current;

    if (!context.deps ||
            context.deps.length !== dependencyList.length ||
            !context.deps.every((val, index) => dependencyList[index] !== val)) {
        context.callback = func;
        context.deps = dependencyList;
    }

    if (!context.debouncer) {
        context.debouncer = function () {
            const self = this;
            const args = arguments;

            if (leading && !context.timer) context.callback.apply(self, args);

            clearTimeout(context.timer);
            context.timer = setTimeout(() => {
                context.timer = null;
                if (!leading) context.callback.apply(self, args)
            }, delay);
        };
    }

    return context.debouncer;
}